import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-type-return",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListTypeReturnComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Returned orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {order_type: "return"}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-type-return",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
